import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import LanguageSelect from "./LanguageSelect";
import { useTranslation } from "react-i18next";
import "./NavBar.css";

const NavBar = () => {
    const { t } = useTranslation();
    const [navBarClassName, setNavBarClassName] = useState("navbar");
    const hamburgerOnClick = () => {
        setNavBarClassName((current) => current === "navbar" ? "navbar open" : "navbar");
    };
    const navBarItemOnClick = () => {
        // Close hamburger menu when navigating to new tab
        setNavBarClassName("navbar");
    };

    const linkClassName = ({ isActive }) => isActive ? "active" : "";

    return (
    <nav aria-label={t("nav.primaryLabel")}>
        <div className={navBarClassName}>
            <button className="hamburgerIcon" onClick={hamburgerOnClick} aria-expanded={navBarClassName !== "navbar"} aria-controls="main-navigation">
                <i className="fa fa-bars" aria-hidden="true"> </i> {navBarClassName === "navbar" ? t("nav.openMenu") : t("nav.closeMenu")}
            </button>
            <div className={"navbarLinks"} id="main-navigation">
                <NavLink to="/" end className={linkClassName} onClick={navBarItemOnClick}>{t("nav.home")}</NavLink>
                <NavLink to="/experience" className={linkClassName} onClick={navBarItemOnClick}>{t("nav.experience")}</NavLink>
                <NavLink to="/skills" className={linkClassName} onClick={navBarItemOnClick}>{t("nav.skills")}</NavLink>
                <NavLink to="/education" className={linkClassName} onClick={navBarItemOnClick}>{t("nav.education")}</NavLink>
                <NavLink to="/about" className={linkClassName} onClick={navBarItemOnClick}>{t("nav.about")}</NavLink>
                <NavLink to="/contact" className={linkClassName} onClick={navBarItemOnClick}>{t("nav.contact")}</NavLink>
                <LanguageSelect />
            </div>
        </div>
    </nav>
    );
}
export default NavBar;
